<template>
  <div class="navbar-fixed" style="z-index: 9999; ">
    <nav>
      <div class="nav-wrapper" :style="'background-color: ' + this.$store.state.empresa.cor_primaria">
        <a href="#" data-target="slide-out" class="sidenav-trigger show-on-large"><i class="material-icons">menu</i></a>
        <a class="brand-logo">
          <div align="center"><img src="../../../src/assets/logo.png" class="logo"></div>
        </a>

        <a class="right" @click="compartilhar()">
          <i class="material-icons" :style="'font-size: 25px; color: #fff;margin-right: 7px;'">share</i>
        </a>

        <ul id="slide-out" class="sidenav" :style="'background-color: ' + this.$store.state.empresa.cor_primaria">
          <li>
            <div class="user-view">
              <a href="#user">
                <img src="../../../src/assets/logo.png" class="logo">
              </a>
            </div>
          </li>
          <li>
            <a href="#!" style="padding: 0 15px;font-size: medium" class="cor-fonte-menu-lateral">
              Departamentos</a>
          </li>
          <li>
            <div class="divider"></div>
          </li>
          <span v-for="grupo in this.grupos" :key="'menugrupomobi-'+grupo.grupo.id" class="cor-fonte-menu-lateral">
            <li class="">
              <ul class="collapsible collapsible-accordion">
                <li>
                  <a class="collapsible-header" style="color: white;    padding: 0px;">
                    <div class="row" style="    margin-bottom: 0px;">
                      <div class="col s2">
                        <i class="material-icons cor-fonte-menu-lateral">arrow_drop_down</i>
                      </div>
                      <div class="col s9">
                        <span class="cor-fonte-menu-lateral ">{{ grupo.grupo.nome }}</span>
                      </div>
                    </div>
                  </a>
                  <div class="collapsible-body collapsible-body-color-up">
                    <ul>
                       <li v-for="secao in grupo.secoes">
                         <a @click="detalhes(grupo,secao.detalhes)" class="waves-effect cor-fonte-menu-lateral">
                           <i class="material-icons cor-fonte-menu-lateral">label</i>{{ secao.detalhes.nome }}</a>
                       </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </li>
          </span>
        </ul>
      </div>
      <slot></slot>
    </nav>
  </div>
</template>

<script>
import SecureLS from "secure-ls";
import Swal from "sweetalert2";

export default {
  name: "NavBar",
  props: ["grupos"],
  updated() {
    $(document).ready(function () {
      $('.dropdown-trigger').dropdown();
      $('.collapsible').collapsible();
    });

    if (document.getElementsByClassName("collapsible-body-color-up")) {
      var itens = document.getElementsByClassName("collapsible-body-color-up");
      for (let i = 0; i <= itens.length; i++) {
        if (document.getElementsByClassName("collapsible-body-color-up")[i]) {
          document.getElementsByClassName("collapsible-body-color-up")[i].style = "background-color: " + this.$store.state.empresa.cor_primaria;
        }
      }
    }

  },
  methods: {
    generateUrl() {
      return `https://pedido.sirruscomercio.app/${this.$store.state.empresa.usuario_url}${(!this.$store.state.is_producao ? '?homologacao=true' : '')}`;
    },
    async compartilhar()
    {
      if (navigator.share)
      {
        this.compartilharComImagem(this.generateUrl());
      } else {
        this.copiarParaAreaDeTransferencia(this.generateUrl());
      }
    },
    async compartilharComImagem(newUrl) {
      navigator.share({
        url: newUrl
      })
        .then(() => console.log('Successful share'))
        .catch((error) => console.error('Error sharing:', error));
    },
    copiarParaAreaDeTransferencia(texto) {
      const el = document.createElement('textarea');
      el.value = texto;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      Swal.fire({
        icon: 'success',
        title: 'Link copiado!',
        text: 'Agora você já pode compartilhar nosso cardápio :)'
      });
    },
    detalhes(grupo, secao = null) {
      $('.sidenav').sidenav('close');
      var ls = new SecureLS();
      ls.set('grupo', grupo);
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/grupo/' + grupo.grupo.nome + '/secao/' + (secao != null ? secao.id : 0))
    },
    Pesquisar() {
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/pesquisar')
    }
  }
}
</script>

<style scoped>

.fonteMenu {
  font-size: small;
}

.sidenav li > a > i, .sidenav li > a > [class^="mdi-"], .sidenav li > a li > a > [class*="mdi-"], .sidenav li > a > i.material-icons {
  float: left;
  height: 48px;
  line-height: 48px;
  margin: 0 25px 0 0;
  width: 10px;
  color: rgba(0, 0, 0, 0.54);
}

.logo {
  padding: 9px;
  width: 210px;
}

@media only screen and (max-width: 992px) {
  .logo {
    padding-top: 5px;
    width: 185px;
  }
}

.sidenav li > a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/NavBar.vue